/* eslint-disable max-len */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	updateDeal  : null,
	companyData : null,
	prodName    : '',
	dealData    : {
		approved : [],
		pending  : [],
		reject   : [],
		expired  : []
	},
	otherDealsData : {
		approved : [],
		pending  : [],
		reject   : [],
		expired  : []
	}
};

export const dealSlice = createSlice({
	name     : 'deal',
	initialState,
	reducers : {
		getUpdateDeal : (state, action) =>
		{
			state.updateDeal = action.payload;
		},
		updateProductName : (state, action) =>
		{
			state.prodName = action.payload;
		},
		getDealRedux : (state, action) =>
		{
			state.dealData = { ...state.dealData, ...action.payload };
		},
		getOthersDealRedux : (state, action) =>
		{
			state.otherDealsData = { ...state.otherDealsData, ...action.payload };
		},
		setCompanyData : (state, action) =>
		{
			state.companyData = action.payload;
		}
	}
});

export const { getUpdateDeal, updateProductName, getDealRedux, getOthersDealRedux, setCompanyData } = dealSlice.actions;
export default dealSlice.reducer;